/*
 * @Description: 邀请落地页多语言配置
 * @FilePath: /weryai-web/locales/modules/invitation.ts
 */
export default {
    zh: {
        invitation: {
            pageTitle: '想免费使用nanobanna、VEO、seedream?注册WeryAI就能领免费积分，立刻就能体验AI创作的乐趣！',
            pageDescription: '注册 微鲤AI 即可获得免费积分，体验 AI 图片生成、AI 视频创作等功能',
            ogTitle: '邀请您加入 微鲤AI - 免费体验 AI 创作',
            ogDescription: '注册 微鲤AI 即可获得免费积分，体验 AI 创作的乐趣',
            invitedToTry: '邀请你来体验 微鲤AI',
            signUpReward: '立即注册即可获得',
            extraCredits: '额外免费积分',
        },
    },
    en: {
        invitation: {
            pageTitle: 'Want to use nanobanna, VEO, seedream for free? Sign up for 微鲤AI to get free credits and start enjoying AI creation!',
            pageDescription: 'Sign up for 微鲤AI to get free credits, experience AI image generation, AI video creation and more',
            ogTitle: 'You are invited to join 微鲤AI - Free AI Creation Experience',
            ogDescription: 'Sign up for 微鲤AI to get free credits and enjoy AI creation',
            invitedToTry: 'has invited you to try 微鲤AI',
            signUpReward: 'Sign up now and get',
            extraCredits: 'extra free credits',
        },
    },
    ja: {
        invitation: {
            pageTitle: 'nanobanna、VEO、seedreamを無料で使いたい？WeryAIに登録して無料クレジットをゲットし、AI創作を楽しもう！',
            pageDescription: 'WeryAIに登録すると無料クレジットがもらえます。AI画像生成、AI動画作成などを体験しよう',
            ogTitle: 'WeryAIへのご招待 - 無料でAI創作を体験',
            ogDescription: 'WeryAIに登録して無料クレジットをゲット、AI創作を楽しもう',
            invitedToTry: 'があなたをWeryAIに招待しました',
            signUpReward: '今すぐ登録して',
            extraCredits: '無料クレジットをゲット',
        },
    },
    ko: {
        invitation: {
            pageTitle: 'nanobanna, VEO, seedream을 무료로 사용하고 싶으세요? WeryAI에 가입하여 무료 크레딧을 받고 AI 창작을 즐기세요!',
            pageDescription: 'WeryAI에 가입하면 무료 크레딧을 받을 수 있습니다. AI 이미지 생성, AI 동영상 제작 등을 체험하세요',
            ogTitle: '微鲤AI 초대 - 무료 AI 창작 체험',
            ogDescription: 'WeryAI에 가입하여 무료 크레딧을 받고 AI 창작을 즐기세요',
            invitedToTry: '님이 WeryAI에 초대했습니다',
            signUpReward: '지금 가입하고',
            extraCredits: '무료 크레딧 받기',
        },
    },
    es: {
        invitation: {
            pageTitle: '¿Quieres usar nanobanna, VEO, seedream gratis? ¡Regístrate en 微鲤AI para obtener créditos gratis y disfruta de la creación con IA!',
            pageDescription: 'Regístrate en 微鲤AI para obtener créditos gratis, experimenta la generación de imágenes con IA, creación de videos con IA y más',
            ogTitle: 'Invitación a 微鲤AI - Experiencia gratuita de creación con IA',
            ogDescription: 'Regístrate en 微鲤AI para obtener créditos gratis y disfruta de la creación con IA',
            invitedToTry: 'te ha invitado a probar 微鲤AI',
            signUpReward: 'Regístrate ahora y obtén',
            extraCredits: 'créditos extra gratis',
        },
    },
    pt: {
        invitation: {
            pageTitle: 'Quer usar nanobanna, VEO, seedream de graça? Cadastre-se no 微鲤AI para ganhar créditos grátis e aproveite a criação com IA!',
            pageDescription: 'Cadastre-se no 微鲤AI para ganhar créditos grátis, experimente geração de imagens com IA, criação de vídeos com IA e mais',
            ogTitle: 'Convite para 微鲤AI - Experiência gratuita de criação com IA',
            ogDescription: 'Cadastre-se no 微鲤AI para ganhar créditos grátis e aproveite a criação com IA',
            invitedToTry: 'convidou você para experimentar 微鲤AI',
            signUpReward: 'Cadastre-se agora e ganhe',
            extraCredits: 'créditos extras grátis',
        },
    },
    de: {
        invitation: {
            pageTitle: 'Möchtest du nanobanna, VEO, seedream kostenlos nutzen? Melde dich bei 微鲤AI an, um kostenlose Credits zu erhalten und genieße KI-Kreation!',
            pageDescription: 'Melde dich bei 微鲤AI an, um kostenlose Credits zu erhalten. Erlebe KI-Bildgenerierung, KI-Videoerstellung und mehr',
            ogTitle: 'Einladung zu 微鲤AI - Kostenlose KI-Kreationserfahrung',
            ogDescription: 'Melde dich bei 微鲤AI an, um kostenlose Credits zu erhalten und genieße KI-Kreation',
            invitedToTry: 'hat dich eingeladen, 微鲤AI auszuprobieren',
            signUpReward: 'Jetzt anmelden und',
            extraCredits: 'Extra-Credits gratis erhalten',
        },
    },
    fr: {
        invitation: {
            pageTitle: 'Vous voulez utiliser nanobanna, VEO, seedream gratuitement ? Inscrivez-vous sur 微鲤AI pour obtenir des crédits gratuits et profitez de la création IA !',
            pageDescription: 'Inscrivez-vous sur 微鲤AI pour obtenir des crédits gratuits, découvrez la génération d\'images IA, la création de vidéos IA et plus',
            ogTitle: 'Invitation à 微鲤AI - Expérience gratuite de création IA',
            ogDescription: 'Inscrivez-vous sur 微鲤AI pour obtenir des crédits gratuits et profitez de la création IA',
            invitedToTry: 'vous a invité à essayer 微鲤AI',
            signUpReward: 'Inscrivez-vous maintenant et obtenez',
            extraCredits: 'crédits supplémentaires gratuits',
        },
    },
    ru: {
        invitation: {
            pageTitle: 'Хотите использовать nanobanna, VEO, seedream бесплатно? Зарегистрируйтесь в 微鲤AI и получите бесплатные кредиты для творчества с ИИ!',
            pageDescription: 'Зарегистрируйтесь в 微鲤AI, чтобы получить бесплатные кредиты. Попробуйте генерацию изображений и видео с ИИ',
            ogTitle: 'Приглашение в 微鲤AI - Бесплатный опыт творчества с ИИ',
            ogDescription: 'Зарегистрируйтесь в 微鲤AI, чтобы получить бесплатные кредиты и наслаждаться творчеством с ИИ',
            invitedToTry: 'приглашает вас попробовать 微鲤AI',
            signUpReward: 'Зарегистрируйтесь сейчас и получите',
            extraCredits: 'дополнительных бесплатных кредитов',
        },
    },
    it: {
        invitation: {
            pageTitle: 'Vuoi usare nanobanna, VEO, seedream gratis? Iscriviti a 微鲤AI per ottenere crediti gratuiti e goditi la creazione con IA!',
            pageDescription: 'Iscriviti a 微鲤AI per ottenere crediti gratuiti, prova la generazione di immagini IA, la creazione di video IA e altro',
            ogTitle: 'Invito a 微鲤AI - Esperienza gratuita di creazione con IA',
            ogDescription: 'Iscriviti a 微鲤AI per ottenere crediti gratuiti e goditi la creazione con IA',
            invitedToTry: 'ti ha invitato a provare 微鲤AI',
            signUpReward: 'Iscriviti ora e ottieni',
            extraCredits: 'crediti extra gratuiti',
        },
    },
    ar: {
        invitation: {
            pageTitle: 'هل تريد استخدام nanobanna و VEO و seedream مجانًا؟ سجّل في 微鲤AI للحصول على رصيد مجاني واستمتع بالإبداع بالذكاء الاصطناعي!',
            pageDescription: 'سجّل في 微鲤AI للحصول على رصيد مجاني، جرّب إنشاء الصور والفيديوهات بالذكاء الاصطناعي',
            ogTitle: 'دعوة إلى 微鲤AI - تجربة مجانية للإبداع بالذكاء الاصطناعي',
            ogDescription: 'سجّل في 微鲤AI للحصول على رصيد مجاني واستمتع بالإبداع بالذكاء الاصطناعي',
            invitedToTry: 'دعاك لتجربة 微鲤AI',
            signUpReward: 'سجّل الآن واحصل على',
            extraCredits: 'رصيد إضافي مجاني',
        },
    },
}
